import { useNavigate } from 'react-router-dom';
import { Footer } from '../First';

export function Frame_op() {
  const navigate = useNavigate();  // Hook initialization

  // Define an array of topics with their names and routes
  const topics = [
    { name: 'Express Js', route: '/FrameWork_ExpressJs' },
    { name: 'Django', route: '/FrameWork_Django' },
    { name: 'Flask', route: '/FrameWork_Flask' },
    { name: 'Spring Boot', route: '/FrameWork_Spring' }
  ];

  return (
    <>
      <div className="front_container">
        <div className="front_contain">
          <h2 className="fr_1">Back End Development</h2>
          <p className="fr_2">
            All resources are available through the links. Kindly refer to this platform.
          </p>

          <p className="fr_rating">4.4 &#9733; &#9733; &#9733; &#9733;</p>
          <p>
            Created by{' '}
            <a
              href="https://www.linkedin.com/in/sayednowshad/"
              style={{ textDecoration: 'underline', fontSize: '17px' }}
            >
              SayedNowshad
            </a>
          </p>
        </div>
      </div>

      <h2 className="fr_des">Description</h2>
      <ul className="fr_list">
        <li>Click below topics for more concepts &#x1F512;</li>
        <li>Select the topic to explore</li>
        <li>
          Use the platform to find the best resources and share them with your friends.
        </li>
        <li>Thanks & Enjoy! <strong>"Stay Hard &#x1F4AA;, Stay Consistently"</strong></li>
      </ul>

      <h3 className="fr_cont">Content</h3>
      <div className="fr_butt">
        {topics.map((topic) => (
          <button
            key={topic.route}
            className="fr_butt_click"
            onClick={() => navigate(topic.route)}
          >
            {topic.name}
          </button>
        ))}
      </div>

      <Footer />
    </>
  );
}

export default Frame_op;
